import { createAction, props } from '@ngrx/store';

const Type = '[Feature Flags]';

export const FeatureFlagsLoadedAction = createAction(
  `${Type} loaded`,
  props<{ flags: Record<string, boolean> }>(),
);

export const FeatureFlagsChangedAction = createAction(
  `${Type} changed`,
  props<{ flags: Record<string, boolean> }>(),
);

export const FeatureFlagsErroredAction = createAction(`${Type} errored`);
